// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-merge-popup-wrapper {
  width: 54.4rem;
}
.work-merge-popup-wrapper h3 {
  font-size: 28px;
}
.work-merge-popup-wrapper .buttons {
  width: 100%;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/ConfirmationPopup/WorkMergeConfirmationPopup/index.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AACE;EACE,eAAA;AACJ;AAEE;EACE,WAAA;EACA,yBAAA;AAAJ","sourcesContent":[".work-merge-popup-wrapper {\n  width: 54.4rem;\n\n  h3 {\n    font-size: 28px;\n  }\n\n  .buttons {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
